import React from "react";
import { ToastContainer } from "react-toastify";

const ReactToast = () => {
  return (
    <ToastContainer style={{ zIndex: 99999 }} />
  );
};

export default ReactToast;